<template>
    <v-img :src="backgroundUrl" class="mnt_image fill-height">
    <div id="main_wrapper">
        <v-snackbar
            :timeout="actionDuration"
            v-model="actionDialog"
            centered
            top
            elevation="20"
            color="error"
            class="pa-6 pt-0"
            style="margin-top: 4%">
            <div class="white--text text-center headline font-weight-medium" v-html="actionMessage"></div>
        </v-snackbar>

        <v-dialog 
            v-model="surveyThanks" 
            width="46%"
            elevation="12">
            <v-card>
                <v-card-title class="headline primary darken-1 white--text">
                    A Debt of Gratitude!
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="surveyThanks = false">
                        <v-icon color="pewter">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <div class="mt-10 mb-5 mx-3 d-block text-center">
                        <div class="my-0 mx-8 text-center d-inline"
                            v-for="expert in survey_team_images"
                            :key="expert.name">
                            <img :src="require(`@/${expert.image}`)" style="width: 112px" :alt="`${expert.name}, ${expert.title}`" :id="expert.name">
                        </div>
                    </div>
                    <div class="ma-5 d-block text-center" style="font-size: 1.1rem">
                        We thank you, {{ client_first_name }}, for taking the time to answer a few questions!<br>
                        It was a pleasure working with you!
                    </div>
                    <div class="ma-5 mb-10 d-block text-center" style="font-size: 1.1rem">
                        - The SRG Team
                    </div>
                    
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-container fluid>
            <v-row>
                <v-col cols="12" class="ma-3 mb-0">
                    <div class="pl-6">
                        <v-icon color="white darken-2" class="mr-3 mt-n1">mdi-ray-end-arrow</v-icon> 
                        <a class="return_link sansation white--text text--darken-2" href="https://www.successionresource.com" target="_blank" >Return to SRG Home Page</a>
                    </div>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12">
                    <div id="login" class="elevation-24" style="background-color: #EFEFEF; width: 46%">
                        <v-img :src="logo_img" width="250" class="d-block mb-12" style="margin: 0 auto" atl="Succession Resource Group"></v-img>
        
                        <HowDidWeDo 
                            v-if="$route.params.sid == 'how_did_we_do'"
                            @submitSurvey="submitSurvey"
                            @getServiceTeam="getServiceTeam" />

                        <div v-else>
                            <template>
                                <v-card width="100%" height="360" class="text-left mb-10 elevation-0 form_wrapper">
                                    <div class="d-block primary py-1">&nbsp;</div>
                                    <div class="d-flex general_grey--text subtitle-1 align-center justify-center" style="width: 100%; height: 92%">
                                        no survey to show
                                    </div>
                                </v-card>
                            </template>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
    </v-img>
</template>

<script>
    import axios from "axios";
    import appUrls from '../helpers/environment';

    import logo_img from '../assets/SRGLogo_full_color_2022.svg';
    import backgroundUrl from '../assets/mycompass_loginbkg_mnt.jpg';

    import HowDidWeDo from '../components/surveys/HowDidWeDo.vue';

    export default {
        name: 'StandAloneSurvey',

        components: {
            HowDidWeDo
        },

        data () {
            return {
                logo_img: logo_img,
                backgroundUrl: backgroundUrl,

                actionDialog: false,
                actionDuration: 6000,
                actionMessage: '',
                
                surveyThanks: false,
                client_first_name: '',
                survey_team_images: []
            }
        },

        created () {
            document.title = 'Follow Up Survey'
        },

        methods: {
            submitSurvey: async function ( surveyData ) {                    
                try {
                    const saved_survey = await axios.post(`${appUrls.api}/api/save_standalone_survey`, {
                        headers: { "Content-Type": "application/json" },
                        data: surveyData,
                        survey_id: 'd3f6cf9d-4a80-4813-96cd-69da1ce3e39d'
                    })
                    
                    if ( saved_survey.data.outcome ) {
                        this.client_first_name = surveyData.client_name.split(' ')[0]
                        this.surveyThanks = true;
                    } else {
                        this.actionMessage = saved_survey.data.message
                        this.actionDialog = true
                    }

                } catch (error) {
                    console.log(error);
                }
            },

            getServiceTeam: async function ( module_name ) { 
                try {
                    const get_service_team = await axios.get(`${appUrls.api}/api/service_team/${module_name}`, {
                        headers: { "Content-Type": "application/json" },
                    })
                    
                    this.survey_team_images = get_service_team.data.outcome && get_service_team.data.module_data ? get_service_team.data.module_data.srg_team.experts : [];
                
                } catch (error) {
                    console.log(error);
                }
            },
            
            
            clearSurvey () {
                this.$refs.form.reset()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #main_wrapper {
        width: 100%;
        height: 100%;
    }
    #login {
        width: 29%;
        margin: 2% auto;
        padding: 3%;
        text-align: center;
        font-size: .8rem;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
    }
    .login_inputs {
        padding: 4px;
        width: 70%;
        font-size: 1em !important;
        border: 1px solid #CCCCCC;
    }
    .right_inputs {
        padding: 8px 4px;
        width: 70%;
        font-size: 1em !important;
        border: 1px solid #CCCCCC;
    }
    .return_link {
        font-size: 1.25rem;
        text-decoration: none;
        /* mdi-keyboard-backspace */
    }
    #login_btn {
        /* padding: 4px; */
        font-size: 1.3em !important;
    }
    .mnt_image {
        background-position: top left; 
        background-repeat: no-repeat; 
        background-attachment: fixed; 
        background-size: cover;
    }
    .signin_title {
        /* color: #37383C; */
        font-weight: 600;
        font-size: 1.6rem !important;
        letter-spacing: 0.05rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/StandAloneSurvey.vue